import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class LoadingService {
  private loadingStates: { [key: string]: BehaviorSubject<boolean> } = {};

  setLoadingState(key: string, state: boolean): void {
    if (!this.loadingStates[key]) {
      this.loadingStates[key] = new BehaviorSubject<boolean>(false);
    }
    this.loadingStates[key].next(state);
  }

  getLoadingState(key: string): BehaviorSubject<boolean> {
    if (!this.loadingStates[key]) {
      this.loadingStates[key] = new BehaviorSubject<boolean>(false);
    }
    return this.loadingStates[key];
  }
}
